import { Link } from "@inertiajs/react"
import { ArrowRight } from "lucide-react"
import posterUrl from "@/assets/econo-pak-testimonial-poster.jpg"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { VideoTestimonial } from "@/components/ui/video-testimonial"
import { toneBg, type SectionTone } from "./section-tone"
import econoPakLogo from "@/assets/client-logos/econo-pak.svg"
import ymlLogo from "@/assets/client-logos/your-memory-lane.png"

// Case studies section: full-width video testimonial cards. Econo-Pak is live
// and links to the full written case study; Your Memory Lane is a placeholder
// that renders only in development until its clip exists.
export function CaseStudies({ tone = "surface" }: { tone?: SectionTone }) {
  return (
    <section
      id="case-studies"
      data-section="case-studies"
      className={cn("scroll-mt-24 border-b border-hairline", toneBg[tone])}
    >
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
        <span className="section-eyebrow">Case studies</span>
        <h2 className="section-title mt-3 max-w-2xl">The full story.</h2>

        <div className="mt-10 flex flex-col gap-4">
          <VideoTestimonial
            videoSrc="/media/econo-pak-testimonial.mp4"
            poster={posterUrl}
            company="Econo-Pak"
            logo={econoPakLogo}
            subheader="Food Co-packer"
            impactTag="Impact"
            impactFacts={[
              <>
                Target customer: <strong>Fortune 500</strong> dry-food brands
              </>,
              "1 → 16 monthly quotes to qualified leads in 8 months",
              "$1M+ per deal",
            ]}
            quote="I've never seen any other PPC company do this before. Our leads are definitely way better quality."
            name="Sarah Richter"
            title="Sales and Marketing Manager"
            playbackRate={1.25}
            cta={
              <Button asChild className="cta-gradient">
                <Link href="/case-studies/econo-pak" data-track-click="econo_pak_case_study">
                  Read the full Econo-Pak story
                  <ArrowRight aria-hidden="true" className="h-4 w-4" />
                </Link>
              </Button>
            }
          />

          {/* Placeholder video testimonial — renders only in development so a
              clip-less card can't ship. To publish: add the cropped video +
              poster, pass videoSrc/poster + the real quote/name, and drop the
              `placeholder` prop and this DEV gate. */}
          {import.meta.env.DEV && (
            <VideoTestimonial
              placeholder
              reverse
              company="Your Memory Lane"
              logo={ymlLogo}
              subheader="Coming soon"
              quote="Video testimonial coming soon."
              name="Client name to follow"
            />
          )}
        </div>
      </div>
    </section>
  )
}
